export default __webpack_public_path__ + "static/media/splash-portrait.0ac6e13b.png";